import React from "react";
import SliderSelectBar from "components/molecules/sliderSelectBar/index.jsx";
import "./styles.scss";

export default class SliderSelect extends React.Component {
  render() {
    return (
      <div className="sliderSelect">
        <SliderSelectBar progress="20" style="inverted" />
        <div className="sliderSelectData">
          <div className="min">Adelanto: $ 50.000</div>
          <div className="max">Total: $ 650.000</div>
          <div className="currentValue">
            <div className="currentValueContent">
              Te financiamos: <span>$ 600.000</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
